export const Drawer_Width = 300;
export const LogFmt = {
    UI: 1,
    API: 2
}
